import React from 'react';
import styles from './description-module.css';

interface DescriptionProps {
    children: React.ReactNode;
    noBottomPadding?: boolean;
}

function Description({ children, noBottomPadding = false }: DescriptionProps): React.ReactElement<DescriptionProps> {
    return (
        <div className={noBottomPadding ? `${styles.Description} ${styles.NoPadding}` : styles.Description}>{children}</div>
    );
}

export default Description;
